/**
 * Shared error message constants for auth cancellation detection.
 * Used by SecretStorageService, ssoService, and isUserAuthCancellation.
 */
export const AUTH_ERROR_MESSAGES = {
  USER_CANCELLED: 'User cancelled password entry',
  MAX_ATTEMPTS_EXCEEDED: 'Max password attempts exceeded',
  SSO_CANCELLED: 'SSO authentication cancelled',
  SSO_TIMED_OUT: 'SSO authentication timed out',
  SSO_POPUP_BLOCKED: 'SSO authentication popup was blocked. Please allow popups for this site.',
  SSO_RETRY_FAILURE: 'SSO authentication was not completed. Please try again.',
  ABORTED: 'Operation aborted',
};

/**
 * Check if an error represents a user-initiated auth cancellation.
 * Covers password entry cancellation, max attempts exceeded, and SSO auth failures.
 *
 * @param {Error} error
 * @returns {boolean}
 */
export function isUserAuthCancellation(error) {
  const msg = error?.message;
  return msg === AUTH_ERROR_MESSAGES.USER_CANCELLED ||
    msg === AUTH_ERROR_MESSAGES.MAX_ATTEMPTS_EXCEEDED ||
    msg === AUTH_ERROR_MESSAGES.SSO_CANCELLED ||
    msg === AUTH_ERROR_MESSAGES.SSO_TIMED_OUT ||
    msg === AUTH_ERROR_MESSAGES.ABORTED;
}

/**
 * Check if an error is an SSO UIA retry failure (server-side timeout, not a user cancellation).
 *
 * @param {Error} error
 * @returns {boolean}
 */
export function isSsoRetryFailure(error) {
  return error?.message === AUTH_ERROR_MESSAGES.SSO_RETRY_FAILURE;
}
